export const getSlackFormatFromHTML = (html: string) => {
  return (
    html
      // Convert formatting tags to Slack style
      .replace(/<strong>(.*?)<\/strong>/gi, "*$1*")
      .replace(/<b>(.*?)<\/b>/gi, "*$1*")
      .replace(/<em>(.*?)<\/em>/gi, "_$1_")
      .replace(/<i>(.*?)<\/i>/gi, "_$1_")
      .replace(/<s>(.*?)<\/s>/gi, "~$1~")
      .replace(/<del>(.*?)<\/del>/gi, "~$1~")
      .replace(/<code>(.*?)<\/code>/gi, "`$1`")
      .replace(/<pre>(.*?)<\/pre>/gi, "```$1```")
      .replace(/<mark>(.*?)<\/mark>/gi, "*$1*") // Highlight as bold since Slack doesn't have highlight
      .replace(/<blockquote>(.*?)<\/blockquote>/gi, "> $1")
      .replace(/<br\s*\/?>(\s*)/gi, "\n")
      .replace(/<\/?p[^>]*>/gi, "\n")

      // Handle headings (convert to bold text)
      .replace(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/gi, "*$1*\n")

      // Handle lists
      .replace(/<li[^>]*>(.*?)<\/li>/gi, "• $1\n")
      .replace(/<\/?[uo]l[^>]*>/gi, "")

      // Handle span tags (preserve content)
      .replace(/<span[^>]*>(.*?)<\/span>/gi, "$1")

      // Handle div tags (preserve content with newline)
      .replace(/<div[^>]*>(.*?)<\/div>/gi, "$1\n")

      // Handle subscript and superscript
      .replace(/<sub>(.*?)<\/sub>/gi, "$1")
      .replace(/<sup>(.*?)<\/sup>/gi, "$1")

      // Handle table elements (simplified as plain text)
      .replace(/<\/?table[^>]*>/gi, "")
      .replace(/<\/?tr[^>]*>/gi, "")
      .replace(/<\/?t[dh][^>]*>/gi, " | ")

      // Convert <a> tags, handling empty hrefs correctly
      .replace(
        /<a\s+(?:[^>]*?\s)?href=(['"])(.*?)\1[^>]*>([\s\S]*?)<\/a>/gi,
        (match, quote, url, text) => (url?.trim() ? `<${url}|${text}>` : text),
      )
  );
};
